import { FC, useState } from "react";
import { DynamicComponentProps } from "@/types/ModuleComponentProp.type.ts";
import styles from './styles/RecordMeasurement.module.scss';
import {
    MeasurementSize
} from "@/features/inspection-details/components/record-measurement/components/MeasurementSize.tsx";
export const RecordMeasurement: FC<DynamicComponentProps> = ({ sizeMeasurements, measurementChangeHandler, defectsChangeHandlers
}: DynamicComponentProps) => {

    const [expandedCard, setExpandedCard] = useState<string | null>(null)


    const handleCardToggle = (id: string | null) => {
        setExpandedCard(prev => (prev === id ? null : id));
    };

    return (
        <>

            <div className={styles.recordMeasurementContainer}>
                {Object.entries(sizeMeasurements ?? {}).map(([sizeKey, measurements], idx) => (

                    <MeasurementSize sizeKey={sizeKey}
                        key={idx}
                        measurements={measurements}
                        handleCardToggle={handleCardToggle}
                        idx={idx.toString()}
                        expandedCard={expandedCard}
                        handleMeasurementChange={measurementChangeHandler ?? (() => null)}
                        onAdd={() => defectsChangeHandlers?.showAddDefect?.(true)}
                    />
                ))}
            </div>
        </>
    );
}

